export const formatPhone = (phone: string): string => {
  let mask = '$1 $2 $3-$4-$5';
  if (/^7\d{10}$/.test(phone)) {
    mask = `+${mask}`;
  }

  return phone.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, mask);
};
